import { Routes } from '@angular/router';

import { HypeComponent } from '../../../Common/Layout/components/Hype/hype.component';
import { TargetingSearchComponent } from '../../Targeting/components/TargetingSearch/targeting-search.component';
import { TargetingSearchDeactivateGuard } from '../guards/targeting-search-deactivate.guard';
import { TargetingResultsComponent } from '../../Targeting/components/TargetingResults/targeting-results.component';

export const targetingSearchRoutes: Routes = [
    {
        path: '',
        component: HypeComponent,
        data: { title: 'Discover.savedSearch.browserTitle' }
    },
    {
        path: 'search',
        canDeactivate: [TargetingSearchDeactivateGuard],
        component: TargetingSearchComponent,
        data: { title: 'Discover.search.browserTitle' }
    },
    {
        path: 'search/update',
        canDeactivate: [TargetingSearchDeactivateGuard],
        component: TargetingSearchComponent
    },
    {
        path: 'search/results',
        canDeactivate: [TargetingSearchDeactivateGuard],
        component: TargetingResultsComponent
    },
    {
        path: 'search/:id',
        canDeactivate: [TargetingSearchDeactivateGuard],
        component: TargetingSearchComponent
    },
    {
        path: 'search/:id/results',
        canDeactivate: [TargetingSearchDeactivateGuard],
        component: TargetingResultsComponent
    },
    {
        path: '**',
        redirectTo: '/Discover/targetingsearches'
    }
];
